<template>
	<div>
		<van-form>
			<van-field v-model="form.process_name" label="流程" readonly />
			<van-field v-model="form.xmmc" label="项目名称" readonly />
			<van-field v-model="form.khh" label="开户行" readonly />
			<van-field v-model="form.je" label="金额" type="numbner" readonly />
			<van-field v-model="form.kksy" label="付款事由" readonly />
			<van-field v-model="form.zbdljglxfs" label="招标代理机构联系方式" readonly />
			<van-field v-model="form.skzh" label="收款账号" readonly />
			<van-field v-model="form.zbdljgskdw" label="招标代理机构收款单位" readonly />
			<van-field v-model="form.xmbh" label="项目编号" readonly />
			<van-field v-model="form.tbgsmc" label="投标公司名称" readonly />
			<van-field v-model="form.gxmbsgmhtbr" label="标书购买和投标人" readonly />
			<van-field v-model="form.remark" rows="3" autosize label="备注" type="textarea" readonly />
		</van-form>
	</div>
</template>

<script>
export default {
	name: "margin",
	props: {
		rform: Object
	},
	data() {
		return {
			form: {}
		};
	},
	watch: {
		rform: {
			immediate: true,
			handler(newV) {
				this.form = newV;
			}
		}
	}
};
</script>